import React from 'react';
import {important, px} from 'csx';
import {stylesheet} from 'typestyle';
import {Moment} from 'moment';

import DateCompareRangeSelector from '../DateCompareRangeSelector';
import {GreyColor, LightGreyColor} from '../../styles/colors';
import {DateRange} from '../../stores/TimeIntervalStore';

interface TogglableDateCompareRangeSelectorProps {
    dateRange: DateRange;
    setDateRange: (dateRange: DateRange) => void;
    mainDateRange: DateRange;
    allowDateRange: boolean;
    setAllowDateRange: (allowDateRange: boolean) => void;
}

export class TogglableDateCompareRangeSelector extends React.Component<TogglableDateCompareRangeSelectorProps, {}> {
    public getStartDate() {
        const {startDate, endDate} = this.props.dateRange;

        if (startDate && endDate) {
            return startDate;
        }
        return null;
    }

    public getSelectableDaysCount() {
        const {startDate, endDate} = this.props.mainDateRange;

        if (startDate && endDate) {
            return endDate.diff(startDate, 'days');
        }
        return 1;
    }

    private toggleAllowDateRange = () => {
        const {allowDateRange, setAllowDateRange} = this.props;
        setAllowDateRange(!allowDateRange);
    };

    public render() {
        const {allowDateRange, setDateRange} = this.props;
        const check = allowDateRange ? <i className="fa fa-check" /> : null;
        return (
            <div>
                <div className={compareSelCss.enabler} onClick={this.toggleAllowDateRange}>
                    {check}
                </div>
                <div style={{display: 'inline-block', verticalAlign: 'top'}}>
                    <DateCompareRangeSelector
                        width={286}
                        alignmentSide="right"
                        onDatesChange={(startDate: Moment | null, endDate: Moment | null) =>
                            setDateRange({startDate: startDate || undefined, endDate: endDate || undefined})
                        }
                        startDate={this.getStartDate()}
                        countSelectableDays={this.getSelectableDaysCount()}
                    />
                </div>
            </div>
        );
    }
}

const compareSelCss = stylesheet({
    enabler: {
        display: 'inline-block',
        verticalAlign: 'top',
        height: 34,
        width: 34,
        border: '1px solid ' + LightGreyColor,
        borderRight: 'none',
        lineHeight: px(31),
        textAlign: important('center'),
        color: GreyColor,
        pointerEvents: 'all',
    },
});



// WEBPACK FOOTER //
// ./src/views/ExplorerParamsBar/TogglableDateCompareRangeSelector.tsx